export { default } from './SectionCoverage';